<template>
    <div class="animated fadeIn container-fluid">
        <b-row>
            <b-col md="6">
                <div class="query-range block-sm text-center">
                    <h5>即時資料更新按鈕 (非自動更新)</h5>
                    <div aria-describedby="input-live-help">
                        <div class="block-text" v-if="draw_device">
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <i class="fa fa-calendar"></i>Due Date
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <div>
                                    <date-picker v-model="due_date"
                                                :lang="$tools.lang.date_picker(language)"
                                                :width="'100%'"
                                                :placeholder="$t('menu.select_date')"
                                                :not-before="draw_device.manufacture"
                                                :not-after="date_today"
                                                format="YYYY-MM-DD HH:mm:ss"
                                    ></date-picker>
                                </div>
                            </b-input-group>
                        </div>

                        <b-button-group>
                            <b-button variant="outline-success" :pressed="activeQueryRage(6)"  @click="setQueryRange(6)">6 {{ $t('u.pictures') }}</b-button>
                            <b-button variant="outline-success" :pressed="activeQueryRage(12)" @click="setQueryRange(12)">12 {{ $t('u.pictures') }}</b-button>
                            <b-button variant="outline-success" :pressed="activeQueryRage(24)" @click="setQueryRange(24)">24 {{ $t('u.pictures') }}</b-button>
                        </b-button-group>
                    </div>
                    <b-form-text id="input-live-help">從這個日期往前撈 {{ this.queryRange }} 張照片</b-form-text>
                </div>
            </b-col>
            <b-col md="3">
                <div class="text-center">
                    <h5>Data Mode</h5>
                    <b-button-group class="block-sm">
                        <b-button variant="outline-dark" :pressed="activeQueryRage('history') == false">Realtime Mode</b-button>
                        <!-- <b-button variant="outline-dark" :pressed="activeQueryRage('history')">History Mode</b-button> -->
                    </b-button-group>
                </div>
            </b-col>
            <b-col md="3">
                <div class="text-center">
                    <h5>更多歷史資料請至愛管侍觀看</h5>
                    <b-button id="button-show" class="btn btn-success px-4 btn-upload"
                            @click="$config.goTo_Iguanshi('camera', { deviceID: deviceID }, 'data')" >

                        <img class="btn-indeedee mr-2" :src="$config.getAssetsURL('img/brand/sidebar_icon.png')" />
                        前往愛管侍儀錶板
                    </b-button>
                </div>
            </b-col>
        </b-row>


        <!-- 阿龜資料讀取畫面 -->
        <div v-if="loading_showInfo">
            <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
        </div>

        <div id="dashboard" v-if="draw_device && deviceData">

            <!-- <TableData :deviceData="deviceData" :sensorParams="draw_device.sensor_params"></TableData> -->

            <h4 class="header-sub">Echarts 圖表</h4>
            <div v-if="deviceData.length > 0">
                <DevicePhoto :id="'device-chart-block-' + draw_device.hashid"
                            :adminTool="true"
                            :autoUpdate="false"
                            :importData="deviceData"
                            :importQuery_Range="queryRange"
                            :importQuery_DataCount="queryRange"
                            :device="draw_device"
                            :showToolbox="true"
                            :project_id="0"
                            :cropperiod_id="0"
                            :project_role="'admin'"
                            :timezone="timezone" >
                </DevicePhoto>
            </div>
            <div v-else>
                <NoData></NoData>
            </div>
        </div>

        <div class="block-area">
            <b-button @click="collapse_relations = !collapse_relations" variant="info" size=lg>
                裝置綁定關聯資訊
                <i :class="$tools.style.classToggle(collapse_relations)"></i>
            </b-button>
            <b-collapse id="collapse_relations" v-model="collapse_relations" class="mt-2">
                <RelationDevice :device_id="deviceID" :alignBlock="6"></RelationDevice>
            </b-collapse>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import AgriLoading  from '@/views/components/AgriLoading'
    import NoData       from '@/views/components/NoData'
    import DevicePhoto  from '@/views/device/Photo_Device'
    import NoteFarmWork from '@/views/project/agriNote/Note_FarmWork'
    import TableData    from '@/views/components/Table_Data'
    import DatePicker from 'vue2-datepicker'
    import RelationDevice from '@/views/admin/device/Relation_Device'
    import ecTools      from '@/echarts/echarts-tools'

    export default {
        components: {
            AgriLoading,
            NoData,
            DevicePhoto,
            NoteFarmWork,
            TableData,
            DatePicker,
            RelationDevice,
        },
        data () {
            return {
                loading_showInfo: false,
                collapse_relations: true,
                deviceData: undefined,
                draw_device: undefined,
                queryRange: 6,
                timezone: 'Asia/Taipei',
                info_type: 'realtime',
                due_date: undefined,
            }
        },
        // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
        beforeRouteUpdate(to, from, next) {
            this.getDevice_byID(to, from, next);

        },
        mounted ()
        {
            this.timezone = this.$tools.date.getTimezoneNow();
            this.due_date = this.date_today;
            this.getDevice_byID();
        },
        computed: {
            ...mapState({
                'language': state => state.user.language,
                'user_admin': state => state.user.is_admin,
                'admin_Device_List': state => state.device.devices,
            }),

            deviceID() {
                return this.$route.params.deviceID;
            },

            // Download Button Check State
            checkDisabled () {

                if (this.due_date == undefined)             return true;
                return false;
            },

            date_today ()
            {
                if ( this.timezone )
                {
                    return this.$tools.date.getDateNow( this.timezone, 'YYYY-MM-DD HH:mm:ss' )
                }
                return this.$tools.date.getDateNow( 'UTC', 'YYYY-MM-DD HH:mm:ss' )
            },
        },
        watch: {

            due_date (val, oldVal)
            {
                if ( val != undefined )
                {
                    this.getData_Realtime()
                }
                else
                {
                    this.due_date = this.date_today;
                }
            },

        },
        methods: {

            setQueryRange (range)
            {
                this.queryRange = range;
                this.info_type = 'realtime';
                this.getData_Realtime();
            },
            activeQueryRage (range)
            {
                if (this.queryRange == range) return true
                return false
            },

            getData_Realtime ()
            {
                if (this.deviceID)
                {
                    this.loading_showInfo = true
                    this.deviceData = undefined

                    let _due_date = this.$tools.date.dataTimeZone_to_UTC( this.due_date, this.timezone );
                    let querySettings = {
                        deviceID: this.deviceID,
                        timezone: this.timezone,
                        limit:    this.queryRange,
                        due_date: _due_date,
                        url:      this.$config.getAPI_URL('Admin_Camera_Realtime', { deviceID: this.deviceID, limit: this.queryRange, due_date: _due_date }),
                    }
                    this.$store.dispatch('camera/getCamera_Realtime_Admin', querySettings)
                        .then( res => {
                            this.loading_showInfo = false
                            this.deviceData = res
                        })
                        .catch( err => {
                            this.loading_showInfo = false

                        })
                }

            },

            getDevice_byID (to = undefined, from = undefined, next = undefined)
            {
                this.deviceData = undefined;
                let _deviceID = (next ? to.params.deviceID : this.deviceID)

                if (_deviceID)
                {
                    this.loading_showInfo = true
                    const settings = {
                        deviceID: _deviceID,
                        timezone: this.timezone,
                    }
                    this.$store.dispatch('device/getDeviceDetail', settings)
                        .then( res => {
                            this.loading_showInfo = false

                            if ( res.device )
                            {
                                res.device.status = ( res.device.status ? res.device.status : this.admin_DeviceStatus_List[0].value )

                                this.draw_device = res.device
                                this.getData_Realtime()
                            }

                            if (next) next();
                        })
                        .catch( err => {
                            this.loading_showInfo = false
                        })
                }
                else
                {
                    this.router.push({ name:'Page 404' })
                }
            },

        }
    }
</script>

<style lang="scss" scoped>


</style>
